var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.classes,
      attrs: { href: _vm.href, id: "phone-button" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.onClick.apply(null, arguments)
        },
      },
    },
    [
      _vm.hideText
        ? _c(
            "svg",
            {
              attrs: {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.0376 5.31642L10.6866 6.47934C11.2723 7.52883 11.0372 8.90557 10.1147 9.82804C10.1147 9.82805 10.1147 9.82804 10.1147 9.82805C10.1146 9.82816 8.99588 10.9471 11.0245 12.9757C13.0525 15.0037 14.1714 13.8863 14.1722 13.8855C14.1722 13.8855 14.1722 13.8855 14.1722 13.8855C15.0947 12.9631 16.4714 12.7279 17.5209 13.3136L18.6838 13.9627C20.2686 14.8471 20.4557 17.0695 19.0628 18.4624C18.2258 19.2994 17.2004 19.9507 16.0669 19.9937C14.1588 20.066 10.9183 19.5831 7.6677 16.3325C4.41713 13.082 3.93421 9.84147 4.00655 7.93333C4.04952 6.79984 4.7008 5.77448 5.53781 4.93748C6.93076 3.54453 9.15317 3.73168 10.0376 5.31642Z",
                  fill: "currentColor",
                },
              }),
            ]
          )
        : _c(
            "svg",
            {
              staticClass: "mr-1 mr-sm-2",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                width: "18",
                height: "18",
              },
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  d: "M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z",
                  "clip-rule": "evenodd",
                },
              }),
            ]
          ),
      _vm._v(" "),
      _vm.buttonText
        ? _c("span", { domProps: { innerHTML: _vm._s(_vm.buttonText) } })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }